function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 496 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M336.5,160C322,70.7 287.8,8 248,8C208.2,8 174,70.7 159.5,160L336.5,160ZM152,256C152,278.2 153.2,299.5 155.3,320L340.6,320C342.7,299.5 343.9,278.2 343.9,256C343.9,233.8 342.7,212.5 340.6,192L155.3,192C153.2,212.5 152,233.8 152,256ZM476.7,160C448.1,92.1 390.2,39.6 318.7,18.4C343.1,52.2 359.9,103.1 368.7,160L476.7,160ZM177.2,18.4C105.8,39.6 47.8,92.1 19.3,160L127.3,160C136,103.1 152.8,52.2 177.2,18.4ZM487.4,192L372.7,192C374.8,213 376,234.5 376,256C376,277.5 374.8,299 372.7,320L487.3,320C492.8,299.5 495.9,278.2 495.9,256C495.9,233.8 492.8,212.5 487.4,192ZM120,256C120,234.5 121.2,213 123.3,192L8.6,192C3.2,212.5 0,233.8 0,256C0,278.2 3.2,299.5 8.6,320L123.2,320C121.2,299 120,277.5 120,256ZM159.5,352C174,441.3 208.2,504 248,504C287.8,504 322,441.3 336.5,352L159.5,352ZM318.8,493.6C390.2,472.4 448.2,419.9 476.8,352L368.8,352C360,408.9 343.2,459.8 318.8,493.6ZM19.3,352C47.9,419.9 105.8,472.4 177.3,493.6C152.9,459.8 136.1,408.9 127.3,352L19.3,352Z",
    style: {
      fill: "rgb(138,138,138)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.50469,0,0,1.50469,-200.019,-108.019)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "148.935px",
    y: "317.385px",
    style: {
      fontFamily: "'Arial-BoldMT', 'Arial', sans-serif",
      fontWeight: 700,
      fontSize: "210.839px"
    }
  }, "EN")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.954ce72d.svg";
export { ForwardRef as ReactComponent };